import { setCookie, parseCookies, destroyCookie } from 'nookies';

// set user to logged in status
export const setLoggedinUser = (data) => {
  setCookie(null, 'loggedin', data?.loggedin, {
    path: '/',
    expires: new Date(data?.expireAt),
  });
};

// get user logged in status
export const getLoggedinUser = () => {
  const cookies = parseCookies();
  const { loggedin } = cookies;
  return loggedin === 'true';
};

// delete user logged in status
export const deleteLoggedinUser = () => {
  destroyCookie(null, 'loggedin');
};

// set user info
export const setUserInfo = (data) => {
  setCookie(null, 'userInfo', JSON.stringify(data), {
    path: '/',
    maxAge: 30 * 24 * 60 * 60, // 30 days
  });
};

// get user info
export const getUserInfo = () => {
  const cookies = parseCookies();
  const { userInfo } = cookies;
  return userInfo;
};

// delete user info
export const deleteUserInfo = () => {
  // destroyCookie(null, "userInfo");
  setCookie(null, 'userInfo', '', {
    path: '/',
    maxAge: 0, // 30 days
  });
  // destroyCookie(null, "accessToken");
  setCookie(null, 'accessToken', '', {
    path: '/',
    maxAge: 0, // 30 days
  });
  // destroyCookie(null, "refreshToken");
  setCookie(null, 'refreshToken', '', {
    path: '/',
    maxAge: 0, // 30 days
  });
  setCookie(null, 'loggedin', '', {
    path: '/',
    maxAge: 0, // 30 days
  });
};

// show user logged in success status modal for once
export const setHasShownLoggedInSuccessModal = () => {
  setCookie(null, 'hasShownLoggedInSuccessModal', true, {
    path: '/',
  });
};

// get user logged in success status modal
export const getHasShowLoggedInSuccessModal = () => {
  const cookies = parseCookies();
  const { hasShownLoggedInSuccessModal } = cookies;
  return hasShownLoggedInSuccessModal === 'true';
};

// delete user logged in success status modal
export const deleteHasShownLoggedInSuccessModal = () => {
  destroyCookie(null, 'hasShownLoggedInSuccessModal');
};

// show user logout success modal for once
export const setHasShownLogoutSuccessModal = () => {
  setCookie(null, 'hasShownLogoutSuccessModal', true, {
    path: '/',
  });
};

// get user logout success status modal
export const getHasShowLogoutSuccessModal = () => {
  const cookies = parseCookies();
  const { hasShownLogoutSuccessModal } = cookies;
  return hasShownLogoutSuccessModal === 'true';
};

// delete user logout success status modal
export const deleteHasShownLogoutSuccessModal = () => {
  destroyCookie(null, 'hasShownLogoutSuccessModal');
};

// set product availability notification
export const setProductAvailabilityNotification = () => {
  setCookie(null, 'productAvailabilityNotification', true, {
    path: '/',
  });
};

// get product availability notification
export const getProductAvailabilityNotification = () => {
  const cookies = parseCookies();
  const { productAvailabilityNotification } = cookies;
  return productAvailabilityNotification === 'true';
};

// delete product availability notification
export const deleteProductAvailabilityNotification = () => {
  destroyCookie(null, 'productAvailabilityNotification');
};

// set a product as wishListed
export const setWishListedProduct = (id) => {
  const cookies = parseCookies();
  const wishlistedProducts = cookies.wishlistedProducts
    ? JSON.parse(decodeURIComponent(cookies.wishlistedProducts))
    : [];

  if (!wishlistedProducts.includes(id)) {
    wishlistedProducts.push(id);
  } else {
    wishlistedProducts.filter((productId) => productId !== id);
  }

  setCookie(
    null,
    'wishlistedProducts',
    encodeURIComponent(JSON.stringify(wishlistedProducts)),
    {
      path: '/',
      maxAge: 30 * 24 * 60 * 60, // 30 days
    },
  );
};

// get all wishListed products
export const getWishListedProduct = () => {
  const cookies = parseCookies();
  const wishlistedProducts = cookies.wishlistedProducts
    ? JSON.parse(decodeURIComponent(cookies.wishlistedProducts))
    : [];
  return wishlistedProducts;
};

// remove a specific product from the wishListed products
export const removeWishListedProduct = (id) => {
  const cookies = parseCookies();
  let wishlistedProducts = cookies.wishlistedProducts
    ? JSON.parse(decodeURIComponent(cookies.wishlistedProducts))
    : [];

  wishlistedProducts = wishlistedProducts.filter(
    (productId) => productId !== id,
  );

  setCookie(
    null,
    'wishlistedProducts',
    encodeURIComponent(JSON.stringify(wishlistedProducts)),
    {
      path: '/',
      maxAge: 30 * 24 * 60 * 60, // 30 days
    },
  );
};

// delete all wishlisted products
export const deleteWishlistedProduct = () => {
  destroyCookie(null, 'wishlistedProducts', {
    path: '/',
  });
};

// set user first visit to the site
export const setUserFirstVisit = () => {
  setCookie(null, 'userFirstVisit', true, {
    path: '/',
  });
};

// get user first visit to the site
export const getUserFirstVisit = () => {
  const cookies = parseCookies();
  const { userFirstVisit } = cookies;
  return userFirstVisit === 'true';
};

// delete user first visit to the site
export const deleteUserFirstVisit = () => {
  destroyCookie(null, 'userFirstVisit');
};
